import { render, staticRenderFns } from "./Carregamento.vue?vue&type=template&id=6a245bb5"
import script from "./Carregamento.vue?vue&type=script&lang=js"
export * from "./Carregamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports